import React from 'react';
import { Button, Space } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  showSubmitSectionConfirmModal,
  showLastSectionCompletionModal,
  switchToNextSection,
  updateSectionRoute,
} from '../../Utils/sectionUtils';
import * as actions from '../../store/actions';
import styles from './ProblemNavigation.scss';

const ProblemNavigation = props => {
  const {
    currentProblemId,
    problems,
    onProblemClick,
    onSubmitSection,
    isSaving,
    handleSidePanelClick,
  } = props;

  const { t } = useTranslation('interview_problem');
  const dispatch = useDispatch();
  const history = useHistory();
  const { sections, currentSectionId, sectionProblems } = useSelector(state => state.assessment);
  const { assessment_id } = useSelector(state => state.invite);
  const switchableSections = useSelector(state => state.assessment.switchableSections);

  const currentIndex = problems.findIndex(p => p.id === currentProblemId);
  const totalProblems = problems.length;
  const currentSectionIndex = sections
    ? sections.findIndex(section => section.id === currentSectionId)
    : -1;
  const isLastSection =
    sections && sections.length > 0 && currentSectionIndex === sections.length - 1;

  const handleNext = async () => {
    if (currentIndex < totalProblems - 1) {
      onProblemClick(problems[currentIndex + 1].id);
    } else {
      const nextSection = sections[currentSectionIndex + 1];
      await updateSectionRoute({
        sections,
        assessmentId: assessment_id,
        sectionId: nextSection.id,
        history,
        handleSidePanelClick: handleSidePanelClick,
        handleMcqSidePanelClick: null,
      });
    }
  };

  const handlePrevious = async () => {
    if (currentIndex > 0) {
      onProblemClick(problems[currentIndex - 1].id);
    } else if (switchableSections && currentSectionIndex > 0) {
      const prevSection = sections[currentSectionIndex - 1];
      await updateSectionRoute({
        sections,
        assessmentId: assessment_id,
        sectionId: prevSection.id,
        history,
        handleSidePanelClick: handleSidePanelClick,
        handleMcqSidePanelClick: null,
        isPrevious: true,
      });
    }
  };

  const handleSubmit = () => {
    const currentSectionIndex = sections.findIndex(section => section.id === currentSectionId);
    if (currentSectionIndex === sections.length - 1) {
      showLastSectionCompletionModal(dispatch, actions, currentSectionId, assessment_id);
    } else {
      showSubmitSectionConfirmModal(dispatch, onSubmitSection, currentSectionId, assessment_id);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.leftButtons}>
        <Space size={20}>
          {(currentIndex > 0 || (switchableSections && currentSectionIndex > 0)) &&
          !(currentIndex === 0 && currentSectionIndex === 0) ? (
            <Button
              disabled={isSaving}
              onClick={handlePrevious}
              className={styles.previousButton}
              type="primary"
              ghost
            >
              {t('navigation.previous')}
            </Button>
          ) : null}

          {(currentIndex < totalProblems - 1 || (switchableSections && !isLastSection)) &&
          !(currentIndex === totalProblems - 1 && isLastSection) ? (
            <Button
              onClick={handleNext}
              type="primary"
              disabled={isSaving}
              className={styles.nextButton}
            >
              {t('navigation.next')}
            </Button>
          ) : null}
        </Space>
      </div>
    </div>
  );
};

export default ProblemNavigation;
